// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1psEi","errorLogs":"styles_errorLogs__2v1_4"};